module.exports = __webpack_public_path__ + "assets/812f203f9add3640d3ef13e41e8e22f6.png";